import { push } from 'react-router-redux';

import { getPersister, getState, getStore } from '../../store';
import ACTIONS from './actions';
import * as UserService from '../../../api/service/userService';
import * as Cookie from '../../../lib/cookie';
import SegmentService from '../../../lib/segment/SegmentService';
import { loadFeaturesForUser } from '../../../v5/features/state/loadFeaturesForUser';

import CONF from '../../../api/config';
import { rollbarSetUserContext } from '../../../lib/rollbarConfig';
import { newRelicSetUserContext } from '../../../lib/newrelicConfig';

export const setError = error => {
    console.error(error);
    getStore().dispatch({
        type: ACTIONS.APP_ERROR,
        appError: true
    });
};

export const clearError = () => {
    getStore().dispatch({
        type: ACTIONS.APP_ERROR,
        appError: false
    });
};

export const logout = () => {
    routeToLogin();
};

const checkHeadCoachRole = async () => {
    const headCoach = await UserService.getHeadCoach();

    if (headCoach.id) {
        return getStore().dispatch({
            type: ACTIONS.APP_SET_HEAD_COACH,
            headCoach
        });
    }

    return;
};

const checkIsCoach = async () => {
    const user = await UserService.getAuthenticatedUser();

    if (!user.isCoach) {
        routeToAccount();
    }

    getStore().dispatch({
        type: ACTIONS.APP_SET_IS_COACH,
        isTrial: user.isTrial,
        isCoach: user.isCoach,
        isBasic: user.isBasic
    });
};

const setHotjarInformation = async () => {
    const loggedInUser = await UserService.getAuthenticatedUser();
    const userProfile = await UserService.getUserProfile(loggedInUser.id);
    if (!loggedInUser || typeof window.hj !== 'function') {
        return;
    }
    const hotjarInformation = {
        userId: loggedInUser.id,
        email: loggedInUser.email,
        isBasicCoach: loggedInUser.isBasic,
        isCoach: true,
        hasAthletePro: userProfile.hasActiveAthleteProLicense
    };

    window.hj('identify', loggedInUser.id, hotjarInformation);
};

export const getCurrentLoggedInUser = async () => {
    const user = await UserService.getUserSimple();
    if (user && user.status !== 401) {
        setCurrentLoggedInUser(user);
        checkIsCoach();
        await checkHeadCoachRole();
        setUserPrefs();
        setUserProfile();
        getStore().dispatch(loadFeaturesForUser());
        setHotjarInformation();
        rollbarSetUserContext(user.id);
        newRelicSetUserContext(user.id);
        return;
    }

    routeToLogin();
};

export const setUserPrefs = async () => {
    if (getState().app.userPrefs) return;
    const userPrefs = await UserService.getPrefs();
    getStore().dispatch({
        type: ACTIONS.APP_SET_USER_PREFS,
        userPrefs
    });
};

export const setUserProfile = async () => {
    if (getState().app.userProfile) return;
    const user = getStore().getState().app.loggedInUser;
    const userProfile = await UserService.getUserProfile(user.id);
    getStore().dispatch({
        type: ACTIONS.APP_SET_USER_PROFILE,
        userProfile
    });
};

export const isAdmin = () => {
    const user = getStore().getState().app.loggedInUser;
    return user && user.roles.indexOf('ADMIN') > -1;
};

export const isCoach = () => {
    const user = getStore().getState().app.loggedInUser;
    return user && user.roles.indexOf('COACH') > -1;
};

export const navigate = destination => {
    if (!isCoach()) {
        logout();
        return;
    }
    getStore().dispatch(push(destination));
};

export const purge = () => {
    getStore().dispatch({
        type: ACTIONS.APP_LOGOUT_USER
    });
    getPersister().purge();
    Cookie.setCookie(CONF.SESSION_NAME, null, 'trainheroic.com');
};

export const routeToLogin = () => {
    purge();
    let url = encodeURIComponent(window.location.href);
    window.location.replace(CONF.LOGIN + `?redirectUrl=${url}`);
};

export const routeToAccount = () => {
    window.location.replace(CONF.URL_ACCOUNT);
};

export const setCurrentLoggedInUser = user => {
    getStore().dispatch({
        type: ACTIONS.APP_LOGIN_USER,
        loggedInUser: user
    });
    SegmentService.identify(user);
};

export const setLoading = message => {
    getStore().dispatch({
        type: ACTIONS.APP_LOADING,
        appLoading: true,
        appMessage: message
    });
};

export const setAnalyticsLoading = message => {
    getStore().dispatch({
        type: ACTIONS.ANALYTICS_LOADING,
        analyticsLoading: true,
        appMessage: message
    });
};

export const setLoginMessage = message => {
    getStore().dispatch({
        type: ACTIONS.APP_SET_LOGIN_MSG,
        message
    });
};

export const stopLoading = message => {
    if (!message) {
        const date = new Date();
        message = `Loaded @ ${date.getHours() % 12 ||
            12}:${`0${date.getMinutes()}`.slice(-2)} ${
            date.getHours() >= 12 ? 'PM' : 'AM'
        }`;
    }
    getStore().dispatch({
        type: ACTIONS.APP_LOADING,
        appLoading: false,
        appMessage: message
    });
};

export const stopLoadingAnalytics = message => {
    if (!message) {
        const date = new Date();
        message = `Loaded @ ${date.getHours() % 12 ||
            12}:${`0${date.getMinutes()}`.slice(-2)} ${
            date.getHours() >= 12 ? 'PM' : 'AM'
        }`;
    }
    getStore().dispatch({
        type: ACTIONS.ANALYTICS_LOADING,
        analyticsLoading: false,
        appMessage: message
    });
};

export const showUnauthorizedDialog = () => {
    getStore().dispatch({
        type: ACTIONS.APP_UNAUTHORIZED_DIALOG,
        unauthorizedDialogOpen: true
    });
};

export const hideUnauthorizedDialog = () => {
    getStore().dispatch({
        type: ACTIONS.APP_UNAUTHORIZED_DIALOG,
        unauthorizedDialogOpen: false
    });
};
